import React, { useEffect, useState } from "react";
import { Card, Headline, Flex, Loading, Paragraph, Button } from "_styleguide";
import { useLead } from "_contexts/useLead";
import { useSettings } from "_contexts/useSettings";
import CanvasConfetti from "canvas-confetti";
import {
  IconExternalLink,
  IconFileTypePdf,
  IconStarFilled,
} from "@tabler/icons-react";
import { previewSteps } from "./_helpers";
import { useStats } from "_contexts/useStats";
import { isDarkColor } from "_helpers/colors";
import "./Success.scss";

function Success(props) {
  const { audit, portalUrl } = useLead();
  const [loading, setLoading] = useState(true);
  const pageSettings = props.settings?.settings;
  const { settings, isPreview } = useSettings();
  const { updateStats } = useStats();
  const { lead } = useLead();
  const primaryColor = settings?.primary_color || "#0f766e";
  const primaryFontColor = isDarkColor(primaryColor) ? "#fff" : "#000";

  const reloadLead = async () => {
    setLoading(false);
    if (pageSettings?.confetti) {
      setTimeout(() => {
        confetti();
      }, 100);
    }
    await updateStats({
      application_id: lead.id,
      self_enrollment_id: settings.id,
      page: props?.settings?.name,
      drop_off_page: null,
    });
  };

  const confetti = async () => {
    CanvasConfetti({
      particleCount: 200,
      spread: 500,
      origin: { y: 0.4 },
      zIndex: 2147483647,
      startVelocity: 30,
    });
  };

  const generateAgreement = async () => {
    const url = audit?.agreement_url;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `Subscription_Agreement_${Date.now()}.pdf`; // the filename you want
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    reloadLead();
  }, []);

  const steps =
    pageSettings?.steps?.length > 0 || !isPreview
      ? pageSettings?.steps
      : previewSteps;

  return loading ? (
    <Loading />
  ) : (
    <Card id="success">
      <div className="apply-form">
        <Headline>{pageSettings?.title}</Headline>
        {pageSettings?.subtitle ? (
          <Paragraph
            opacity={0.6}
            align="left"
            size="14px"
            dangerouslySetInnerHTML={{
              __html: pageSettings?.subtitle,
            }}
          />
        ) : null}
        <Flex vertical style={{ marginTop: "24px" }} gap="16px">
          <Button
            block
            size="large"
            style={{ background: primaryColor, color: primaryFontColor }}
            onClick={() => generateAgreement()}
          >
            <IconFileTypePdf />{" "}
            {pageSettings?.button_text || "Download Agreement"}
          </Button>
          {portalUrl ? (
            <Button
              block
              size="large"
              style={{
                background: primaryColor,
                color: primaryFontColor,
                marginTop: "16px",
              }}
              onClick={() => window.open(portalUrl, "_blank")}
            >
              <IconExternalLink /> View Customer Portal
            </Button>
          ) : null}
        </Flex>
        <Flex vertical className="success-steps" gap="20px">
          <Headline>{pageSettings?.steps_title || "Next Steps"}</Headline>
          {steps?.map((step, index) => (
            <Flex key={`step-${index}`} gap="12px">
              <IconStarFilled />
              <Flex vertical gap="6px">
                <Headline>{step.title}</Headline>
                <Paragraph size="13px" opacity={0.6}>
                  {step.description}
                </Paragraph>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </div>
    </Card>
  );
}

export default Success;
